import ClientLogger from './clientLogger';

const FACEBOOK_SETTINGS_MAP = {
    'localhost': {
        socialHost: 'social.stage.homeaway.com',
        appId: 155404361189801
    },
    'localhost.com': {
        socialHost: 'social.stage.homeaway.com',
        appId: 155404361189801
    },
    'homeaway.localhost': {
        socialHost: 'social.stage.homeaway.com',
        appId: 176278865785256
    },
    'vrbo.localhost': {
        socialHost: 'social.stage.homeaway.com',
        appId: 206287156074616
    },
    'local.homelidays.es': {
        socialHost: 'social.homeaway.com',
        appId: 958959140937389
    },
    'local.abritel.fr': {
        socialHost: 'social.stage.homeaway.com',
        appId: 216495905037464
    },
    'local.vrbo.com': {
        socialHost: 'social.stage.vrbo.com',
        appId: 109213082502054
    },
    'local.fewo-direkt.de': {
        socialHost: 'social.stage.homeaway.com',
        appId: 160652240666876
    },
    'local.fr.homeaway.ca': {
        socialHost: 'social.stage.homeaway.com',
        appId: 128528480560007
    },
    'local.homeaway.co.uk': {
        socialHost: 'social.stage.homeaway.com',
        appId: 150947144978961
    },
    'local.homeaway.com.ar': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'local.homeaway.at': {
        socialHost: 'social.stage.homeaway.com',
        appId: 216722541738655
    },
    'local.homeaway.jp': {
        socialHost: 'social.stage.homeaway.com',
        appId: 216722541738655
    },
    'abritel.fr': {
        socialHost: 'social.homeaway.com',
        appId: 210126639025536
    },
    'aluguetemporada.com.br': {
        socialHost: 'social.homeaway.com',
        appId: 209459075759568
    },
    'fewo-direkt.de': {
        socialHost: 'social.homeaway.com',
        appId: 128002723946928
    },
    'fr.homeaway.ca': {
        socialHost: 'social.homeaway.com',
        appId: 176677122390129
    },
    'homeaway.co.uk': {
        socialHost: 'social.homeaway.com',
        appId: 191612647555578
    },
    'homeaway.at': {
        socialHost: 'social.homeaway.com',
        appId: 257265161001223
    },
    'homeaway.com.au': {
        socialHost: 'social.homeaway.com',
        appId: 176962292361464
    },
    'stayz.com.au': {
        socialHost: 'social.homeaway.com',
        appId: 176962292361464
    },
    'homeaway.ca': {
        socialHost: 'social.homeaway.com',
        appId: 128944923850903
    },
    'homeaway.com.co': {
        socialHost: 'social.homeaway.com',
        appId: 168262816569205
    },
    'homeaway.com': {
        socialHost: 'social.homeaway.com',
        appId: 174366222619074
    },
    'luxury.homeaway.com': {
        socialHost: 'social.homeaway.com',
        appId: 174366222619074
    },
    'homeaway.co.in': {
        socialHost: 'social.homeaway.com',
        appId: 223143287703401
    },
    'homeaway.co.nz': {
        socialHost: 'social.homeaway.com',
        appId: 455487181161072
    },
    'bookabach.co.nz': {
        socialHost: 'social.homeaway.com',
        appId: 455487181161072
    },
    'homeaway.dk': {
        socialHost: 'social.homeaway.com',
        appId: 128693037210786
    },
    'homeaway.es': {
        socialHost: 'social.homeaway.com',
        appId: 120290661389436
    },
    'homeaway.fi': {
        socialHost: 'social.homeaway.com',
        appId: 1295839347151836
    },
    'homeaway.it': {
        socialHost: 'social.homeaway.com',
        appId: 230220910326999
    },
    'homeaway.com.mx': {
        socialHost: 'social.homeaway.com',
        appId: 1762647237360709
    },
    'homeaway.nl': {
        socialHost: 'social.homeaway.com',
        appId: 400009137046079
    },
    'homeaway.no': {
        socialHost: 'social.homeaway.com',
        appId: 203285933505567
    },
    'homeaway.pt': {
        socialHost: 'social.homeaway.com',
        appId: 1860413537565319
    },
    'homeaway.se': {
        socialHost: 'social.homeaway.com',
        appId: 748103608704813
    },
    'ownersdirect.co.uk': {
        socialHost: 'social.homeaway.com',
        appId: 132344663970987
    },
    'vrbo.com': {
        socialHost: 'social.vrbo.com',
        appId: 232223133460554
    },
    'homeaway.gr': {
        socialHost: 'social.homeaway.com',
        appId: 560429950766895
    },
    'homeaway.pl': {
        socialHost: 'social.homeaway.com',
        appId: 1710867789211219
    },
    'homelidays.com': {
        socialHost: 'social.homeaway.com',
        appId: 278229565951848
    },
    'homelidays.it': {
        socialHost: 'social.homeaway.com',
        appId: 963084767161022
    },
    'homelidays.es': {
        socialHost: 'social.homeaway.com',
        appId: 692112134295560
    },
    'vacationrentals.com': {
        socialHost: 'social.vacationrentals.com',
        appId: 1375264539207158
    },
    'homeaway.lk': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.cl': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.co': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.com.ar': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.com.cn': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.com.my': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.com.pe': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.com.sg': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.com.uy': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.ec': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.ph': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.ru': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.co.kr': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.co.th': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.com.vn': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.hk': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.id': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.jp': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'homeaway.tw': {
        socialHost: 'social.homeaway.com',
        appId: 246920655340133
    },
    'stage.abritel.fr': {
        socialHost: 'social.stage.homeaway.com',
        appId: 218616934825671
    },
    'stage.aluguetemporada.com.br': {
        socialHost: 'social.stage.homeaway.com',
        appId: 217815528240857
    },
    'stage.fewo-direkt.de': {
        socialHost: 'social.stage.homeaway.com',
        appId: 228890220454386
    },
    'stage.fr.homeaway.ca': {
        socialHost: 'social.homeaway.com',
        appId: 103380066421518
    },
    'stage.homeaway.co.uk': {
        socialHost: 'social.stage.homeaway.com',
        appId: 178338138886049
    },
    'stage.homeaway.co.nz': {
        socialHost: 'social.stage.homeaway.com',
        appId: 106973762796393
    },
    'stage.bookabach.co.nz': {
        socialHost: 'social.stage.homeaway.com',
        appId: 106973762796393
    },
    'stage.homeaway.com.ar': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.at': {
        socialHost: 'social.stage.homeaway.com',
        appId: 155443997894330
    },
    'stage.homeaway.com.au': {
        socialHost: 'social.stage.homeaway.com',
        appId: 202799066431823
    },
    'stage.homeaway.ca': {
        socialHost: 'social.stage.homeaway.com',
        appId: 102098883216214
    },
    'stage.homeaway.co': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.com': {
        socialHost: 'social.stage.homeaway.com',
        appId: 223242541035731
    },
    'luxury-stage.homeaway.com': {
        socialHost: 'social.stage.homeaway.com',
        appId: 223242541035731
    },
    'cas-stage.homeaway.com': {
        socialHost: 'social.stage.homeaway.com',
        appId: 223242541035731
    },
    'stage.homeaway.dk': {
        socialHost: 'social.stage.homeaway.com',
        appId: 168573503206240
    },
    'stage.homeaway.es': {
        socialHost: 'social.stage.homeaway.com',
        appId: 205880156123789
    },
    'stage.homeaway.fi': {
        socialHost: 'social.stage.homeaway.com',
        appId: 124898097591508
    },
    'stage.homeaway.co.in': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.it': {
        socialHost: 'social.stage.homeaway.com',
        appId: 230220910326999
    },
    'stage.homeaway.nl': {
        socialHost: 'social.stage.homeaway.com',
        appId: 216036205095513
    },
    'stage.homeaway.com.mx': {
        socialHost: 'social.stage.homeaway.com',
        appId: 160107347388893
    },
    'stage.homeaway.no': {
        socialHost: 'social.stage.homeaway.com',
        appId: 228413807185035
    },
    'stage.homeaway.pt': {
        socialHost: 'social.stage.homeaway.com',
        appId: 192760300771148
    },
    'stage.homeaway.se': {
        socialHost: 'social.stage.homeaway.com',
        appId: 190923107625925
    },
    'stage.ownersdirect.co.uk': {
        socialHost: 'social.stage.homeaway.com',
        appId: 179318072124302
    },
    'stage.vrbo.com': {
        socialHost: 'social.stage.vrbo.com',
        appId: 124450337638403
    },
    'stage.homeaway.gr': {
        socialHost: 'social.stage.homeaway.com',
        appId: 629705233827091
    },
    'stage.homeaway.pl': {
        socialHost: 'social.stage.homeaway.com',
        appId: 402088900169654
    },
    'stage.homelidays.com': {
        socialHost: 'social.stage.homeaway.com',
        appId: 923024571167979
    },
    'stage.homelidays.it': {
        socialHost: 'social.homeaway.com',
        appId: 1249106871869873
    },
    'stage.homelidays.es': {
        socialHost: 'social.homeaway.com',
        appId: 107072019810406
    },
    'stage.vacationrentals.com': {
        socialHost: 'social.stage.vacationrentals.com',
        appId: 740054666164700
    },
    'stage.homeaway.lk': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.cl': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.com.cn': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.com.my': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.com.pe': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.com.sg': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.com.uy': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.ec': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.de': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.ph': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.ru': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.co.kr': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.co.th': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.com.vn': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.hk': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.id': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.jp': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'stage.homeaway.tw': {
        socialHost: 'social.stage.homeaway.com',
        appId: 159072491337276
    },
    'test.abritel.fr': {
        socialHost: 'social.stage.homeaway.com',
        appId: 216495905037464
    },
    'test.fewo-direkt.de': {
        socialHost: 'social.stage.homeaway.com',
        appId: 160652240666876
    },
    'test.fr.homeaway.ca': {
        socialHost: 'social.stage.homeaway.com',
        appId: 128528480560007
    },
    'test.homeaway.co.uk': {
        socialHost: 'social.stage.homeaway.com',
        appId: 150947144978961
    },
    'test.homeaway.com.ar': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.at': {
        socialHost: 'social.stage.homeaway.com',
        appId: 216722541738655
    },
    'test.homeaway.ca': {
        socialHost: 'social.stage.homeaway.ccom',
        appId: 102098883216214
    },
    'test.homeaway.com': {
        socialHost: 'social.stage.homeaway.com',
        appId: 214276818594151
    },
    'luxury-test.homeaway.com': {
        socialHost: 'social.stage.homeaway.com',
        appId: 214276818594151
    },
    'local.homeaway.com': {
        socialHost: 'social.stage.homeaway.com',
        appId: 214276818594151
    },
    'cas-test.homeaway.com': {
        socialHost: 'social.stage.homeaway.com',
        appId: 214276818594151
    },
    'test.homeaway.com.au': {
        socialHost: 'social.stage.homeaway.com',
        appId: 232355823447356
    },
    'test.homeaway.co.nz': {
        socialHost: 'social.stage.homeaway.com',
        appId: 408693902531641
    },
    'test.bookabach.co.nz': {
        socialHost: 'social.stage.homeaway.com',
        appId: 408693902531641
    },
    'test.homeaway.dk': {
        socialHost: 'social.stage.homeaway.com',
        appId: 128562707222964
    },
    'test.homeaway.es': {
        socialHost: 'social.stage.homeaway.com',
        appId: 218505198169378
    },
    'test.homeaway.co.in': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.it': {
        socialHost: 'social.stage.homeaway.com',
        appId: 171544982905463
    },
    'test.homeaway.com.mx': {
        socialHost: 'social.stage.homeaway.com',
        appId: 190761167642816
    },
    'test.homeaway.nl': {
        socialHost: 'social.stage.homeaway.com',
        appId: 216201598414227
    },
    'test.homeaway.no': {
        socialHost: 'social.stage.homeaway.com',
        appId: 171012689625753
    },
    'test.homeaway.pt': {
        socialHost: 'social.stage.homeaway.com',
        appId: 221229267894962
    },
    'test.homeaway.se': {
        socialHost: 'social.stage.homeaway.com',
        appId: 171502289576202
    },
    'test.ownersdirect.co.uk': {
        socialHost: 'social.stage.homeaway.com',
        appId: 205904176119591
    },
    'test.vrbo.com': {
        socialHost: 'social.stage.vrbo.com',
        appId: 109213082502054
    },
    'test.homeaway.gr': {
        socialHost: 'social.stage.homeaway.com',
        appId: 789666784457552
    },
    'test.homeaway.pl': {
        socialHost: 'social.stage.homeaway.com',
        appId: 417671541925591
    },
    'test.homelidays.com': {
        socialHost: 'social.stage.homeaway.com',
        appId: 656718087846825
    },
    'test.homelidays.it': {
        socialHost: 'social.homeaway.com',
        appId: 1714068882219402
    },
    'test.homelidays.es': {
        socialHost: 'social.homeaway.com',
        appId: 958959140937389
    },
    'test.vacationrentals.com': {
        socialHost: 'social.stage.vacationrentals.com',
        appId: 1774052049590533
    },
    'test.homeaway.lk': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.cl': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.co': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.com.cn': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.com.my': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.com.pe': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.com.sg': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.com.uy': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.ec': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.ph': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.ru': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.co.kr': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.co.th': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.com.vn': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.hk': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.id': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.jp': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.tw': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.fi': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.homeaway.de': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1931748713753630
    },
    'test.stayz.com.au': {
        socialHost: 'social.stage.homeaway.com',
        appId: 232355823447356
    },
    'stage.stayz.com.au': {
        socialHost: 'social.stage.homeaway.com',
        appId: 202799066431823
    },
    'test.homeaway.com.br': {
        socialHost: 'social.stage.homeaway.com',
        appId: 797315507323547
    },
    'test.aluguetemporada.com.br': {
        socialHost: 'social.stage.homeaway.com',
        appId: 797315507323547
    },
    'identity-auth-ui-dev-ustst1-01.wvrgroup.internal': {
        socialHost: 'social.stage.homeaway.com',
        appId: 185688351887352
    },
    'identity-auth-ui-dev-usstg1-01.wvrgroup.internal': {
        socialHost: 'social.stage.homeaway.com',
        appId: 1183308035090139
    }
};


// per https://developers.facebook.com/docs/messenger-platform/messenger-profile/supported-locales
// we want to only pick locales that facebook supports
const localeMap = {
    // custom mappings here
    da: 'da_DK',
    de: 'de_DE',
    en: 'en_US',
    es: 'es_LA',
    en_AU: 'en_GB',
    en_GB: 'en_GB',
    en_IN: 'en_GB',
    en_US: 'en_US',
    es_ES: 'es_ES',
    fi: 'fi_FI',
    fr: 'fr_FR',
    fr_CA: 'fr_CA',
    it: 'it_IT',
    nb: 'nb_NO',
    nl: 'nl_NL',
    no: 'nb_NO',
    // base locales here
    no_NO: 'nb_NO',
    pt_BR: 'pt_BR',
    pt_PT: 'pt_PT',
    ko_KR: 'ko_KR',
    nl_NL: 'nl_NL',
    ru_RU: 'ru_RU',
    zh_CN: 'zh_CN',
    zh_HK: 'zh_HK',
    zh_TW: 'zh_TW',
    ja_KS: 'ja_KS',
    pl_PL: 'pl_PL',
    fi_FI: 'fi_FI',
    vi_VN: 'vi_VN',
    sv_SE: 'sv_SE',
    el_GR: 'el_GR',
    es_LA: 'es_LA',
    ja_JP: 'ja_JP',
    tr_TR: 'tr_TR'
};


function getLocale(locale) {
    if (locale) {
        let localParts = locale.split('_');
        if (localParts.length > 2) {
            locale = `${localParts[0]}_${localParts[1]}`;
        }
        let returnLocale = localeMap[locale] ? localeMap[locale] : localeMap[locale.split('_')[0]];
        return returnLocale || 'en_US';
    }
    return 'en_US';
}

/**
 * Get the corresponding facebook settings as per the given domain and locale
 * @param domain String
 * @param locale String
 * @returns {any | {}} Object
 */
function get(domain, locale) {
    if (domain && domain.indexOf('www.') === 0) {
        domain = domain.substring(4);
    }
    let settings = FACEBOOK_SETTINGS_MAP[domain];

    if (!settings) {
        ClientLogger.logError(`[ALERT] There are no facebook settings for the specified domain=${domain}`);
        settings = FACEBOOK_SETTINGS_MAP['homeaway.com'];
    }
    settings.trackingHost = settings.socialHost.replace('social.', 'facebook.');
    settings.locale = getLocale(locale);

    return settings;
}

export {
    get
};
